import { Box } from '@mui/material';
import { REACTION_EMOJIS } from 'constants/reactions';
import PropTypes from 'prop-types';
import React from 'react';

const ReactionIcon = ({ name }) => {
  if (name === 'care') {
    return (
      <Box
        component="img"
        src="/reactions/care.svg"
        alt={name}
        sx={{ width: '1em', height: '1em', verticalAlign: 'middle', display: 'inline-block' }}
      />
    );
  }
  if (REACTION_EMOJIS[name]) {
    return REACTION_EMOJIS[name];
  }
  return (
    <Box
      component="span"
      sx={{
        fontSize: '1.15em',
        lineHeight: 1,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {name}
    </Box>
  );
};

ReactionIcon.propTypes = {
  name: PropTypes.string.isRequired,
};

export default ReactionIcon;
